import React, { Component } from 'react';
import NavBar from '../Components/NavBar/NavBar.js';
import './Catalogo.css';
import FooterContatos from '../Components/Footer/FooterContatos.js';
import Footer from '../Components/Footer/Footer.js';
import servico1 from '../Images/servicoss/servico1.jpg';
import servico2 from "../Images/servicoss/servico2.jpg";
import servico3 from "../Images/servicoss/servico3.jpg";
import servico4 from "../Images/servicoss/servico4.jpg";
import servico5 from "../Images/servicoss/servico5.jpg";
import servico6 from "../Images/servicoss/servico6.jpg";
import FloatingWhatsApp from 'react-floating-whatsapp';
import LOGOL from '../Images/logo2.png';

class Servicos extends Component {
 render() {
 return (
   <div className="backGBlack2">
   <NavBar/>
   <br></br>
   <div className="CatalogoPageCss2">
   <img  src={servico1} alt="servico1"></img>
   <img  src={servico2} alt="servico2"></img>
   <img  src={servico3} alt="servico3"></img>
   <img  src={servico4} alt="servico4"></img>
   <img  src={servico5} alt="servico5"></img>
   <img  src={servico6} alt="servico6"></img>
   </div>
   <Footer/>
   <FooterContatos/>
   <FloatingWhatsApp avatar={LOGOL} position="absolute" accountName="Centro Oeste" allowClickAway="true" placeholder="Escreva sua mensagem"  chatMessage="Olá, como posso te ajudar?" statusMessage="online" allowEsc="true" phoneNumber="5567998383492"/>
</div>
 );
 }
}
export default Servicos;